import { render } from "./Meigaranewsrecentl.vue?vue&type=template&id=dcb69760&scoped=true"
import script from "./Meigaranewsrecentl.vue?vue&type=script&lang=js"
export * from "./Meigaranewsrecentl.vue?vue&type=script&lang=js"

import "./Meigaranewsrecentl.vue?vue&type=style&index=0&id=dcb69760&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb69760"]])

export default __exports__